// extracted by mini-css-extract-plugin
export default {"grey_wrap":"ui_grey_wrap__zAQ8T","grey_header":"ui_grey_header__uSsSy","title":"ui_title__T28Pm"};